import { actions as globalActions, CONSTANTS } from 'src/redux';
import httpClient from 'src/helpers/httpClient';

export const TYPES = {
  DELETE_MENU: 'MENU::DELETE_MENU'
};

const remove = (id) => async (dispatch) => {
  dispatch({
    type: TYPES.DELETE_MENU,
    status: CONSTANTS.STATUS.FETCHING
  });
  try {
    const client = await httpClient();
    await client.delete(`menu/${id}`);
    dispatch({
      type: TYPES.DELETE_MENU,
      status: CONSTANTS.STATUS.DONE
    });
    dispatch(globalActions.menu.listMenu.list());
  } catch (error) {
    console.log(error);
    dispatch({
      type: TYPES.DELETE_MENU,
      status: CONSTANTS.STATUS.FAILED
    });
  }
};

const actions = {
  remove
};

export default actions;
